import { createSlice } from "@reduxjs/toolkit";

const initialPaymentState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  entitiesTraffic: null,
  exportData: null,
  currency: null,
  lastError: null,
  paymentForEdit: undefined,
  paymentForValid: undefined,
  paymentForExport: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState: initialPaymentState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    paymentFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    exportPayment: (state, action) => {
      const { totalCount, entities, currency } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = entities;
      state.currency = currency;
      state.totalCount = totalCount;
    },
    exportFetchedPayment: (state, action) => {
      const { totalCount, export_data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = export_data;
      state.totalCount = totalCount;
    },
    trafficPayment: (state, action) => {
      const { totalCount, entities, currency } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entitiesTraffic = entities;
      state.currency = currency;
      state.totalCount = totalCount;
    },
    paymentCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.payment.push(action.payload.payment);
    },
    paymentDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.payment.filter(
        (el) => el.payment_id !== action.payload.id,
      );
    },
    paymentDisabled: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.payment.filter(
        (el) => el.payment_id !== action.payload.id,
      );
    },
    getPayment: (state, action) => {
      state.actionsLoading = false;
      state.paymentForEdit = action.payload.paymentForEdit;
      state.error = null;
    },
    getPaymentValid: (state, action) => {
      state.actionsLoading = false;
      state.paymentForValid = action.payload.paymentForValid;
      state.error = null;
    },
    getExportPayment: (state, action) => {
      state.actionsLoading = false;
      if (action.payload.paymentForExport === undefined) {
        state.paymentForExport = [];
      } else {
        state.paymentForExport.push(action.payload.paymentForExport);
      }
      state.error = null;
    },
    // updateProduct
    paymentUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.payment = state.entities.payment.map((entity) => {
        if (entity.payment_id === action.payload.payment.payment_id) {
          return action.payload.payment;
        }
        return entity;
      });
    },
  },
});
